
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6470_7419)"}},[_c('path',{attrs:{"d":"M17.672 3.75a.834.834 0 01.245.59v14.41a.833.833 0 01-.834.833H2.917a.833.833 0 01-.834-.833V1.25a.833.833 0 01.834-.833h11.077c.221 0 .433.088.59.244l3.088 3.09z"}}),_c('path',{attrs:{"d":"M8.322 6.772a.833.833 0 00-1.239.728v6.25a.833.833 0 001.239.729l5.416-3.334a.834.834 0 000-1.457L8.322 6.772z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6470_7419"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    